import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import mutator from 'mutator';
import qs from 'qs';
import { query } from '../gql/getWaivers';

export default graphql(
  gql`
    mutation CreateWaiver($input: CreateWaiverInput!) {
      createWaiver(input: $input) {
        id
        name
        waiver_id
        company
        type
        status
      }
    }
  `,
  {
    props: ({ mutate }) => ({
      createWaiver: async (input) => {
        return mutator(() =>
          mutate({
            variables: { input },
            refetchQueries: () => {
              const search = qs.parse(window.location.search, {
                ignoreQueryPrefix: true,
              });
              return [{ query, variables: { input: search } }];
            },
          })
        );
      },
    }),
  }
);
